/** Sign-off the server adds to action-item replies (po_email.PURCHASING_SIGNATURE). */
export const PURCHASING_SIGNOFF =
  'Thank you,\nUSA Restaurant Suppliers\nPurchasing Department\npo@shopusars.com'

/** Sign-off for invoice conversations, which go out from accounting@. */
export const ACCOUNTING_SIGNOFF =
  'Thank you,\nUSA Restaurant Suppliers\nAccounting Department\naccounting@shopusars.com'

/** Sign-off the server adds to replies from warranty@ (warranty.constants.REPLY_SIGNATURE, USA-915). */
export const WARRANTY_SIGNOFF =
  'Thank you,\nUSA Restaurant Suppliers Warranty\nwarranty@shopusars.com'

/** The parts of a staff member's profile their personal signature is built from. */
export interface SignatureProfile {
  name?: string | null
  email?: string | null
  title?: string | null
  staff_phone?: { phone: string } | null
}

/**
 * A staff member's own sign-off (USA-1557), from their profile's name, title and phone:
 * "Thank you,\nKinslee Zielinski\nCOO | USA Restaurant Suppliers\n425-308-4701".
 */
export function personalSignoff(profile: SignatureProfile): string {
  const name = profile.name?.trim() || profile.email?.trim() || ''
  const title = profile.title?.trim()
  const phone = profile.staff_phone?.phone.trim()
  return [
    'Thank you,',
    name,
    title ? `${title} | USA Restaurant Suppliers` : 'USA Restaurant Suppliers',
    phone,
  ]
    .filter(Boolean)
    .join('\n')
}

export function formatFileSize(bytes: number): string {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}

export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'))
    reader.onload = () => {
      const result = reader.result
      if (typeof result !== 'string') {
        reject(new Error('Failed to read file as data URL'))
        return
      }
      const comma = result.indexOf(',')
      resolve(comma >= 0 ? result.slice(comma + 1) : result)
    }
    reader.readAsDataURL(file)
  })
}

export function parseCcString(ccJson: string | null | undefined): string {
  if (!ccJson) return ''
  try {
    const parsed: unknown = JSON.parse(ccJson)
    return Array.isArray(parsed)
      ? parsed.filter((e): e is string => typeof e === 'string').join(', ')
      : ''
  } catch {
    return ''
  }
}

export function splitEmails(input: string): string[] {
  return input
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
}
